import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../component/sidebar';
import AdminProfile from '../component/admin/adminProfile';
import Copyright from '../component/Copyright';
import { TiThMenu } from "react-icons/ti";
import { MdArrowBackIos } from "react-icons/md";


function AdminLayout() {
  const [showmenu, setshowmenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setshowmenu(false); // hide sidebar on route change
  }, [location]);


  return (
    <div className='w-full h-[100vh] flex relative'>
      {/* Sidebar */}
      <div className={`lg:w-[20%] w-[250px] ${showmenu ? 'block fixed top-0 left-0 z-50 h-full' : 'hidden'} lg:static lg:block bg-[#2A3650]`}>
        <Sidebar closemenu={<div onClick={() => setshowmenu(false)} className='p-2 bg-[#374462] h-[40px] rounded-lg lg:invisible visible'>
              <MdArrowBackIos className='text-white text-[24px] cursor-pointer transition-transform duration-500 hover:rotate-180' />
            </div>} showClose={!showmenu ? false : true} onClose={() => setshowmenu(false)} />
      </div>

      {/* Main Content */}
      <div className={`${showmenu ? 'lg:w-[80%]' : 'lg:w-full'} w-full overflow-y-auto`}>
        <div className='w-full bg-[#F4F7F9]'>
          <AdminProfile menuicon={
            <div onClick={() => setshowmenu(!showmenu)} className='p-2 bg-[#374462] h-[40px] rounded-lg lg:invisible visible'>
              <TiThMenu className='text-white text-[24px] cursor-pointer transition-transform duration-500 hover:rotate-180' />
            </div>
          } />
          <Outlet />
        </div>
        <Copyright />
      </div>
    </div>
  );
}

export default AdminLayout;
